// Async Thunk for fetching about us data
import axios from "axios";
import { createAsyncThunk } from "@reduxjs/toolkit";
const BASE_URL = process.env.REACT_APP_BASE_URL;

export const fetchAboutUs = createAsyncThunk(
  "aboutUs/fetchAboutUs",
  async (lang, { rejectWithValue }) => {
    try {
      const response = await axios.get(`${BASE_URL}/about-us`, {
        headers: {
          'Accept-Language': lang || 'en',
          'Accept': 'application/json'
        }
      });
     
      return response.data;
    } catch (error) {
      const message = error.response?.data?.message || "Failed to fetch about us data";
      return rejectWithValue({ message });
    }
  }
);